/* eslint-disable no-magic-numbers */

import { Link } from "react-router-dom";

import { routes } from "routes";
import { nFormatter } from "utils/parseNumber";
import { className } from "utils/strings";
import { SeeAllButton } from "components/buttons";
import { Columnizer } from "components/blocks";
import { PinkBaseButton, SECONDARY, PRIMARY } from "components/buttons/PinkBaseButton";
import PROFILE_ICON from "components/icons/profileIcon.svg";
import BROKEN_IMAGE from "components/icons/default_userpic.svg";
import "./NicheListWidget.scss";

const LIST_SIZE = 4;
const COLUMN_SIZES = [500];

export interface INicheInfo {
  id: string;
  name: string;
  image: string | null;
  subscribers: number;
  following?: boolean;
}

export const NicheListWidget = (props: {
  title: string;
  link: string;
  className?: string;
  niches: INicheInfo[];
  page: number;
  onFollow: (id: string, value: boolean) => void;
}): JSX.Element => {
  const onClick = (item: INicheInfo) => () => {
    props.onFollow(item.id, !item.following);
  };

  return (
    <div className={className({
      "nicheListWidget": true,
      [props.className ?? ""]: props.className !== undefined,
    })}>
      <h5 className="header">{props.title}</h5>

      <Columnizer className="rows" sizes={COLUMN_SIZES}>
        {props.niches.slice(
          props.page === 1 ? 0 : LIST_SIZE * (props.page - 1), LIST_SIZE * props.page
        ).map((el: INicheInfo, index: number) => (
          <div className="row" key={el.id}>
            <Link to={routes.niche(el.id)} className="pic">
              <img src={el.image || BROKEN_IMAGE} alt=""/>
            </Link>
            <div className="title">
              <div className="name">
                <Link to={routes.niche(el.id)}>{el.name}</Link>
              </div>
              <div className="subscribers">
                <img src={PROFILE_ICON} alt="profile"/>
                <span>{nFormatter(el.subscribers)}</span>
              </div>
            </div>
            <PinkBaseButton
              variant={el.following ? SECONDARY : PRIMARY}
              onClick={onClick(el)}
            >
              {el.following ? "Following" : "Follow"}
            </PinkBaseButton>
          </div>
        ))}
      </Columnizer>
      <div className="more">
        <SeeAllButton link={props.link} />
      </div>
    </div>
  );
};
